import { withMotion } from '@hoc/withMotion';
import PersonCard from '@stories/Components/Cards/PersonCard/PersonCard';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './PeopleCards.styles';
const PeopleCards = (props) => {
    if (!props.cards) {
        return null;
    }
    return (React.createElement(S.Container, { id: props.anchorId, translations: props.translations },
        React.createElement(HeadingSummaryBlock, { ...props, summary: props.summary ? `<p>${props.summary}</p>` : undefined, layout: 'central' }),
        React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
            React.createElement(CarouselProvider, { count: props.cards.length, paddingOffset: 16 },
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { trackMutations: true }, props.cards.map((card) => (React.createElement(S.Item, { key: card.id },
                        React.createElement(PersonCard, { ...card, headingType: "h3" }))))),
                    React.createElement(Pagination, null))))));
};
export default withMotion(PeopleCards);
